(function() {

  'use strict';

  angular.module('mgpCorregedoriaApp.info').controller('InfoController', InfoController);

  function InfoController(InfoService) {
    var vm = this;

    vm.init = init;
    vm.getInfo = getInfo;

    vm.init();

    function init() {
      vm.getInfo();
    }

    function getInfo() {
      InfoService.getInfo().then(data => {
        vm.apiVersion = `v${data.version}-${data.date}`;
      });
    }
  }

})();